define('js/lib/auth',[
    'js/config/clientSideConfig',
    'js/globals/vizia_access_token',
    'donny-auth'
], function (
    clientSideConfig,
    kioskAuth,
    TokenStore
) {
    'use strict';
    var store;

    function getStore(otp) {
        var config = clientSideConfig();
        if (!store) {
            if (otp) {
                store = TokenStore.fromOTP(config.authStoreDomain, otp);
            } else {
                store = Promise.resolve(new TokenStore(config.authStoreDomain));
            }
        }
        return store;
    }

    function getAuthObject() {
        var token = kioskAuth.getJwt();

        if (token) {
            return Promise.resolve({usePlatformAuth: true, idToken: token});
        }

        return getStore()
            .then(function (store) {
                return store.getToken({aud: 'vizia.brandwatch.com/foot-gun', secondsValidFor: 60 * 30});
            })
            .then(function (token) {
                return {usePlatformAuth: true, idToken: token};
            });
    }

    function upgradeAuth(api2token) {
        return getStore()
            .then(function (store) {
                return store.upgradeToken({
                    aud: 'vizia.brandwatch.com/foot-gun',
                    secondsValidFor: 60 * 30,
                    api2_token: api2token
                });
            })
            .then(function (token) {
                if (token !== null) {
                    return {usePlatformAuth: true, idToken: token};
                }
                return location.replace(getStore().loginUrl);
            });
    }

    return {
        getStore: getStore,
        getAuthObject: getAuthObject,
        upgradeAuth: upgradeAuth,
        reset: function () {
            store = null;
        }
    };
});
